import React, { useEffect, useState, useContext } from 'react'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import MainHeader from '../components/MainHeader';
import Main from '../components/Main';
import { Box } from '@mui/system';
import { Button, CircularProgress, IconButton, InputAdornment, Menu, MenuItem, Tab, TextField } from '@mui/material';
import { Link, useNavigate } from "react-router-dom";


import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';


import { toast } from 'react-toastify';


import { AuthContext } from '../utils/AuthContext';

import { deleteUser, fetchAllUsers, resetPassword } from '../services/UserService';

import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AlertDialog from '../components/AlertDialog';
import Global from '../utils/Global';

const columns = [
  { id: 'given_name', label: 'First Name', width: '100px' },
  { id: 'last_name', label: 'Last Name', width: '100px' },
  { id: 'nick_name', label: 'Nickname', width: 70 },

  {
    id: 'email',
    label: 'Email',
    width: 70,
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'role',
    label: 'Role',
    width: 70,
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'action',
    label: 'Action',
    width: 70,
    format: (value) => value.toLocaleString('en-US'),
  },

];


function Users() {
  const [rows, setRows] = useState([]);

  const navigate = useNavigate('');

  const [open, setOpen] = useState(localStorage.getItem('quoting-drawer-open') == 'true');

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogDeleteOpen, setDeleteDialogOpen] = useState(false);
  const [agentSelected, setAgentSelected] = useState('');

  const [commissionCount, setCommissionCount] = useState(0);

  const [mode, setMode] = useState("create");

  const { auth, setAuth } = useContext(AuthContext);

  const [openResetPassDialog, setOpenResetPassDialog] = useState(false);
  const [openDeleteUserDialog, setOpenDeleteUserDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
      if (auth.user.role_id === Global.ROLE_ADMIN || auth.user.role_id === Global.ROLE_SUPER_ADMIN) {
        // User is authorized, do nothing
      } else {
        // User is not authorized, redirect
        navigate('/quotation');
      }
    }, []);

  useEffect(() => {
    handleFetchUsers();
  }, []);

  function handleFetchUsers() {
    setLoading(true);

    fetchAllUsers({ token: auth.token }).then(res => {
      setRows(res.data.users);
      setLoading(false);
    });
  }

  async function handleResetPassword() {

    await resetPassword({ token: auth.token, userId: selectedUser.id });

    // await handleFetchEmployees();

    toast.success(selectedUser.nick_name + " password reset successful", {
      autoClose: 1000,
      hideProgressBar: true,
    });
  }

  async function handleDeleteUser() {

    await deleteUser({ token: auth.token, userId: selectedUser.id }).then(res => {
      handleFetchUsers();

      toast.success("User " + selectedUser.nick_name + " has been deleted successfully", {
        autoClose: 1000,
        hideProgressBar: true,
      });
    }).catch(err => {
      toast.error("User " + selectedUser.nick_name + " deletion failed", {
        autoClose: 1000,
        hideProgressBar: true,
      });
    });




  }


  return (


    <Box sx={{ display: 'flex' }}>

      <MainHeader open={open} setOpen={setOpen} />
      <Main open={open} sx={{ pt: 10, overflow: 'hidden' }} >
        <AlertDialog title='Password Reset'
          content={'Do you want to reset password for ' + selectedUser.nick_name + '?'}
          open={openResetPassDialog}
          setOpen={setOpenResetPassDialog}
          positiveButtonLabel='Confirm'
          negativeButtonLabel='Cancel'
          callback={() => {
            handleResetPassword()
            setOpenResetPassDialog(false);
          }} />
        <AlertDialog title='User Delete'
          content={'Do you want to delete user ' + selectedUser.nick_name + '?'}
          open={openDeleteUserDialog}
          setOpen={setOpenDeleteUserDialog}
          positiveButtonLabel='Confirm'
          negativeButtonLabel='Cancel'
          callback={() => {
            handleDeleteUser()
            setOpenDeleteUserDialog(false);
          }} />
        <ToastContainer />

        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, mb: 2 }}>
          <Button variant='contained' onClick={() => {
            navigate('/add_user')
          }}>Add New User</Button>
        </Box>

        <Paper sx={{ overflowX: 'auto', width: '100%', pb: '5px', maxHeight: '80vh' }}>
          <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 700 }} >
            <TableHead sx={{ zIndex: 1000 }}>
              <TableRow >
                {columns.map((column) => {
                  if (column.label === 'User Name') {
                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth, position: "sticky", left: 0, background: 'white' }}
                        sx={{ fontWeight: 600, fontSize: '18px', zIndex: 1000 }}
                      >
                        {column.label}
                      </TableCell>
                    );
                  }
                  else {
                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        sx={{ fontWeight: 600, fontSize: '18px' }}
                      >
                        {column.label}
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {
                isLoading ? <TableRow><TableCell colSpan={6} align='center'><CircularProgress /></TableCell></TableRow> :
                  rows.map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          let role = ''
                          if (row['role_id'] == 1) {
                            role = 'Admin'
                          } else if (row['role_id'] == 2) {
                            role = 'User'
                          }
                          {
                            if (column.label === 'Full Name') {
                              return (
                                <TableCell style={{ position: "sticky", left: 0, background: 'white', zIndex: 100 }} sx={{ fontSize: '18px' }} key={column.id} align={column.align}>
                                  {row['first_name'] + row['last_name']}
                                </TableCell>
                              );
                            } else if (column.label === 'Role') {

                              return (
                                <TableCell style={{ left: 0, background: 'white', zIndex: 100 }} sx={{ fontSize: '18px' }} key={column.id} align={column.align}>
                                  {role}
                                </TableCell>
                              );
                            }
                            else if (column.label === 'Action') {
                              return (
                                <TableCell style={{ right: 0, background: 'white', zIndex: 100 }} sx={{ fontSize: '18px' }} key={column.id} align={column.align}>
                                  <PopupState variant="popover" popupId="popup-menu">
                                    {(popupState) => (
                                      <React.Fragment>
                                        <IconButton {...bindTrigger(popupState)} size='sm'><ExpandMoreIcon /></IconButton>
                                        <Menu {...bindMenu(popupState)}>
                                          <MenuItem onClick={() => {
                                            navigate('/update_user/' + row.id)
                                            popupState.close();
                                          }}>Update</MenuItem>
                                          <MenuItem onClick={() => {
                                            setOpenResetPassDialog(true)
                                            setSelectedUser(row)
                                            popupState.close();
                                          }}>Reset Pass</MenuItem>
                                          <MenuItem onClick={() => {
                                            setOpenDeleteUserDialog(true)
                                            setSelectedUser(row)
                                            popupState.close();
                                          }}>Delete</MenuItem>
                                        </Menu>
                                      </React.Fragment>

                                    )}
                                  </PopupState>
                                </TableCell>
                              );
                            }

                            else {
                              return (
                                <TableCell style={{ left: 0, background: 'white', zIndex: 100 }} sx={{ fontSize: '18px' }} key={column.id} align={column.align}>
                                  {value}
                                </TableCell>
                              );
                            }
                          }


                        })}
                      </TableRow>
                    );
                  })
              }
            </TableBody>
          </Table>
        </Paper>
      </Main>
    </Box>

  )
}

export default Users